import { useEffect, useRef } from "react";
import { useAuthStore, selectIsAuthenticated } from "@safers/auth";
import { stompService } from "../services/stomp.service";
import type { ConnectionStatus } from "../services/stomp.service";
import { useEventsStore } from "../stores/events.store";
import type { StompEventResponse } from "../services/types";

export function useStompEvents() {
  const isAuthenticated = useAuthStore(selectIsAuthenticated);
  const addStompEvent = useEventsStore((s) => s.addStompEvent);
  const setConnectionStatus = useEventsStore((s) => s.setConnectionStatus);
  const unsubscribeRef = useRef<(() => void) | null>(null);

  useEffect(() => {
    if (!isAuthenticated) return;

    const onStatus = (status: ConnectionStatus) => {
      setConnectionStatus(status);

      if (status === "connected") {
        unsubscribeRef.current?.();
        unsubscribeRef.current = stompService.subscribe("/topic/events", (message) => {
          try {
            const event: StompEventResponse = JSON.parse(message.body);
            addStompEvent(event);
          } catch {
            return;
          }
        });
      }
    };

    stompService.connect(onStatus);

    return () => {
      unsubscribeRef.current?.();
      unsubscribeRef.current = null;
      stompService.disconnect(onStatus);
    };
  }, [isAuthenticated, addStompEvent, setConnectionStatus]);
}
